import { Component, Input, isDevMode, AfterViewInit } from '@angular/core';
import { RoutingAuthenticationService } from '../../services/routing-authentication';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { Configuration } from '../../configurations/shared.config';
import { DiagnosticsService } from '../../services/diagnostics.service';

@Component({
    moduleId: module.id,
    selector: 'diagnostics-component',
    template: `
        <span *ngIf='dev'>
             
            <button onclick="$('#__diagnostics__').toggleClass('open');">
                <span class='glyphicon glyphicon-cog' aria-hidden="true"></span>
            </button>
            <div class='diagnostics' id="__diagnostics__">
                <input [(ngModel)]='showAliveOnly' type='checkbox' id='showAliveOnly'/>
                <label for='showAliveOnly'>Show Alive Only</label>
                <table class="table table-hover table-striped table-bordered">
                    <tr>
                        <th>Name</th>
                        <th>Alive</th>
                        <th>Dead</th>
                    </tr>
                    <tr *ngFor='let s of services'>
                        <td>{{s.key}}</td>
                        <td>{{s.alive}}</td>
                        <td>{{s.dead}}</td>
                    </tr>
                </table>
            </div>

        </span>
    `,
    styles: [
        `
        .diagnostics {
            position : absolute;
            left: 50px;
            top : 50px;
            background-color: white;
            border: 2px solid #7cbabc;
            opacity : 0.95;
            padding: 2px;
            min-width: 250px;
            max-height: 400px;
            overflow-y : scroll;
            border-radius: 5px;
            -moz-transition: all 0.1s ease-in;
            -o-transition: all 0.1s ease-in;
            -webkit-transition: all 0.1s ease-in;
            -ms-transition: all 0.1s ease-in;
            transition: all 0.1s ease-in;

            -ms-transform: scale(0, 0);
            -webkit-transform: scale(0, 0);
            transform: scale(0, 0);
            transform-origin: left center;
        }
        .diagnostics.open {

            -ms-transform: scale(1, 1);
            -webkit-transform: scale(1, 1);
            transform: scale(1, 1);
        }
        button {
            background: transparent;
            border: 0px;
            color: #ddd;
            font-size: 13pt;
            width: 50px;
            padding-top: 15px;
            margin-bottom: 2px;
            border-top: 1px solid #444;
        }
        `
    ]
})
export class DiagnosticsComponent {

    showAliveOnly: boolean = true;

    get services() {
        return this.showAliveOnly ?
            this.diag.RegisteredServices.filter(x => x.alive) :
            this.diag.RegisteredServices;
    }

    dev: boolean = isDevMode();

    constructor(private diag: DiagnosticsService) {

    }
}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/diagnostics/diagnostics.component.ts